import { useTranslation } from 'react-i18next';
import useDocumentTitle from '../../../hooks/DocumentTitle/documentTitle';
import { IMovieItem } from '../../../services/supportMovie/supportMovie.types';
import { MovieIframe } from '../MovieIframe/MovieIframe.component';
import { useStyles } from './MovieWatch.styles';

interface MovieProps {
  movie: IMovieItem | undefined;
}

export const MovieWatch: React.FC<MovieProps> = ({ movie }) => {
  const { t } = useTranslation();
  useDocumentTitle(t('global:sidebar.supportMovie'));
  const classes = useStyles();

  const movieStyleProps = {
    position: 'absolute',
    top: '0',
    left: '20%',
    width: '60%',
    height: '50%',
    border: 'none',
  };

  return (
    <div className={classes.movieWatchContainer}>
      <div className={classes.movieWatchIframeContainer}>
        <MovieIframe movieUrl={movie?.url} movieStyle={movieStyleProps}></MovieIframe>
      </div>
    </div>
  );
};
